/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { GetInvoiceNumberApiParameter, getInvoicePDF } from "@eisinc/App/Services/GetInvoicePdfService";
import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type Parameter = GetInvoiceNumberApiParameter & HasOnSuccess<any> & HasOnError<unknown>;

interface Props {
    apiResult: any;
    apiParameter: GetInvoiceNumberApiParameter;
    error?: unknown;
}

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { invoiceNumber: props.parameter.invoiceNumber };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await getInvoicePDF(props.apiParameter);
    } catch (e) {
        props.error = true;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);

    if (!props.error) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);

    if (props.error) {
        props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const getInvoicePdf = createHandlerChainRunner(chain, "getInvoicePdf");
export default getInvoicePdf;
